module.exports = __webpack_public_path__ + "static/media/cara_happy_eyes_open_mouth_open.7c9d91f5.png";